import * as Icons from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export default function Tabs({
    tabs,
    icons,
    activeTab = 0,
    width = 'w-50',
    accentColor = 'bg-white',
    onChangeActiveTab,
}: {
    tabs?: string[];
    icons?: string[];
    activeTab?: number;
    width?: string;
    accentColor?: string;
    onChangeActiveTab: (tab: number) => void;
}) {
    const getLength = () => {
        return tabs ? tabs.length : icons?.length || 0;
    };

    const getIconButton = (icon: string, isActive: boolean) => {
        const Icon = Icons[icon as keyof typeof Icons] as LucideIcon;
        return <Icon size={20} className={`transition-all duration-300 mx-auto ${isActive ? 'text-stone-800' : 'text-stone-500'}`} />;
    };

    const renderButton = (content: string, key: number) => (
        <button
            key={key}
            className={`flex-1 z-10 py-2 px-3 rounded-md transition-colors duration-300 text-center ${
                activeTab === key ? 'text-stone-800 font-medium' : 'text-stone-500 hover:text-stone-800 cursor-pointer'
            }`}
            onClick={() => onChangeActiveTab(key)}
        >
            {icons ? getIconButton(content, activeTab === key) : content}
        </button>
    );

    return (
        <div className={`relative flex ${width} bg-stone-100 rounded-md`}>
            <span
                className={`absolute top-1 bottom-1 ${accentColor} rounded-md transition-all duration-300 ease-in-out shadow-sm`}
                style={{
                    left: `calc(0.25em + ${activeTab * (100 / getLength())}%)`,
                    width: `calc(${100 / getLength()}% - 0.5em)`,
                }}
            />
            {(icons || tabs)?.map((item, key) => renderButton(item, key))}
        </div>
    );
}
